import Footer from "./components/footer/footer";
import Home from "./pages/home/home";

function App() {
  return (
    <div id="body">
      <Home />
      <Footer />
    </div>
  );
}

export default App;
